module.exports = __webpack_public_path__ + "static/portfolio-mas-4-88243963509e13aa5b5d19d728fbe455.jpg";